const istitutiOptions = [
  { value: 'AIDEXA', label: 'AIDEXA' },
  { value: 'ALBA LEASING', label: 'ALBA LEASING' },
  { value: 'BANCA SISTEMA', label: 'BANCA SISTEMA' },
  { value: 'BANCA VALSABBINA', label: 'BANCA VALSABBINA' },
  { value: 'BANCA VENETO CENTRALE', label: 'BANCA VENETO CENTRALE' },
  { value: 'BCC TRIUGGIO E DELLA VALLE DEL LAMBRO', label: 'BCC TRIUGGIO E DELLA VALLE DEL LAMBRO' },
  { value: 'BENE BANCA', label: 'BENE BANCA' },
  { value: 'BNL', label: 'BNL' },
  { value: 'CF+', label: 'CF+' },
  { value: 'CONFESERFIDI', label: 'CONFESERFIDI' },
  { value: 'MCC', label: 'MEDIO CREDITO CENTRALE (MCC)' },
  { value: 'PERMICRO', label: 'PERMICRO' },
  { value: 'BANCA PIÙ S.p.A.', label: 'BANCA PIÙ S.p.A.' },
  { value: 'ISTITUTO NON CONVENZIONATO', label: 'ISTITUTO NON CONVENZIONATO' },
];

export const istitutiDropdownOptions = istitutiOptions.map((option) => ({
  key: option.value,
  value: option.value,
  text: option.label,
}));

export default istitutiOptions;



// WEBPACK FOOTER //
// ./app/shared/constants/istitutiOptions.js